// extracted by mini-css-extract-plugin
export default {"root":"divider_root__c4nNS","variant-dashed":"divider_variant-dashed__th7+q"};